
export const ClientHubBadge = ({ status }: { status?: string }) => {
  const map: Record<string, { label: string; classes: string }> = {
    synced: { label: "Synced", classes: "bg-blue-50 text-blue-700 border-blue-200" },
    pending: { label: "Syncing...", classes: "bg-yellow-50 text-yellow-700 border-yellow-200" },
    failed: { label: "Failed", classes: "bg-red-50 text-red-700 border-red-200" },
    not_synced: { label: "Not Linked", classes: "bg-neutral-100 text-neutral-600 border-neutral-200" },
  };
  const s = status || "not_synced";
  const conf = map[s] || map.not_synced;
  if (!conf) return null;
  return (
    <span className={`inline-flex items-center border px-2 py-0.5 rounded-full text-[11px] ${conf.classes}`}>
      {conf.label}
    </span>
  );
};

